/**
 * 이미지 서비스 (ranking_product_image) 연동
 *
 * 로컬: frontend/.env.development.local
 *   REACT_APP_IMAGE_SERVICE_URL=http://localhost:5002
 *
 * 운영: frontend/.env.production
 *   REACT_APP_IMAGE_SERVICE_URL=https://img.mbizsquare.com
 */

const DEFAULT_IMAGE_SERVICE_URL = 'http://localhost:5002';

export const IMAGE_SERVICE_URL = (
  process.env.REACT_APP_IMAGE_SERVICE_URL || DEFAULT_IMAGE_SERVICE_URL
).replace(/\/$/, '');

export const imageApiUrl = (path = '') => {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${IMAGE_SERVICE_URL}${normalized}`;
};

/** 업로드 URL — 기본은 메인 서버 프록시 (로컬 세션 SSO). 운영 직접 업로드: REACT_APP_IMAGE_DIRECT_UPLOAD=true */
export const getImageUploadUrl = () => {
  if (process.env.REACT_APP_IMAGE_DIRECT_UPLOAD === 'true') {
    return imageApiUrl('/api/v1/files');
  }
  return '/api/image/v1/files';
};

/**
 * 업로드된 이미지 URL 표시용
 * - /uploads, /files → 이미지 서버
 * - /static/img/profile → 이미지 서버 (채팅과 동일 경로 통일)
 * - 그 외 /static → 메인 정적 자산
 */
export const resolveImageUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  if (url.startsWith('/static/img/profile/')) {
    return `${IMAGE_SERVICE_URL}${url}`;
  }
  if (url.startsWith('/static/')) return url;
  if (url.startsWith('/uploads/') || url.startsWith('/files/')) {
    return `${IMAGE_SERVICE_URL}${url}`;
  }
  return url;
};

const DEFAULT_POST_THUMBNAIL = '/static/img/assets/thumb_adv.png';

/** 게시글 리스트 썸네일 (API: thumbnail | post_thumbnail) */
export const resolvePostThumbnailUrl = (post, fallback = DEFAULT_POST_THUMBNAIL) => {
  const raw = post?.thumbnail || post?.post_thumbnail;
  if (raw) return resolveImageUrl(raw);
  // if (post?.post_has_img && fallback) return fallback;
  return null;
};

const parseUploadResponse = async (response) => {
  const responseText = await response.text();
  let result = null;
  try {
    result = responseText ? JSON.parse(responseText) : null;
  } catch (_) {
    result = null;
  }

  if (!response.ok) {
    throw new Error(
      result?.error ||
      result?.message ||
      responseText?.slice(0, 120) ||
      '이미지 업로드에 실패했습니다.'
    );
  }

  if (!result || result.code === 'fail') {
    throw new Error(result?.message || result?.error || '이미지 업로드에 실패했습니다.');
  }

  return result;
};

/**
 * @param {File} file
 * @param {'post'|'profile'|'banner'} type
 * @param {string} fieldName - form field (image | file | userProfileImg)
 * @param {{ withThumb?: boolean }} [options]
 */
export const uploadImageFile = async (file, type, fieldName = 'image', options = {}) => {
  const formData = new FormData();
  formData.append(fieldName, file);
  formData.append('type', type);
  if (type === 'post' && options.withThumb === false) {
    formData.append('withThumb', 'false');
  }

  const response = await fetch(getImageUploadUrl(), {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  return parseUploadResponse(response);
};
